<template>
  <!-- 提货派车 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button
          class="glo_btnItems glo_bgcMainColor"
          @click="addNewDispatch()"
          v-permission="permission('add')"
          >新建
        </el-button>
        <el-button
          v-permission="permission('confirm')"
          class="glo_btnItems"
          @click="dispatchConfirm()"
          >发车确认</el-button
        >
        <el-button
          class="glo_btnItems"
          @click="intoStoreage()"
          v-if="dispatchType === 'shang_men_ti_huo'"
          v-permission="permission('into:storage')"
          >卸货入库</el-button
        >
        <el-button
          class="glo_btnItems"
          @click="finishDispatch()"
          v-permission="permission('finish')"
          >发车完成</el-button
        >
        <el-button
          class="glo_btnItems"
          @click="batchSignDispatch()"
          v-if="dispatchType === 'song_huo_shang_men'"
          v-permission="permission('sign')"
          >批量签收</el-button
        >
        <el-button
          class="glo_btnItems"
          @click="feeCheckIn()"
          v-permission="permission('fee:checkin')"
          >费用录入</el-button
        >
        <el-button
          class="glo_btnItems"
          @click="batchCheckFee()"
          v-permission="permission('check')"
          >批量过账</el-button
        >
        <el-button
          class="glo_btnItems"
          @click="batchCheckFeeOut()"
          v-permission="permission('uncheck')"
          >批量反过账</el-button
        >
        <template v-if="dispatchType === 'gan_xian_pei_zai'">
          <el-button
            class="glo_btnItems"
            @click="passingBranches()"
            v-permission="permission('tu:jing:wang:dian')"
            >途径网点</el-button
          >
          <el-button
            class="glo_btnItems"
            @click="arriveMidway()"
            v-permission="permission('zhong:tu:dao:che')"
            >中途到车</el-button
          >
          <el-button
            class="glo_btnItems"
            @click="departureMidway()"
            v-permission="permission('zhong:tu:fa:che')"
            >中途发车</el-button
          >
          <el-button
            class="glo_btnItems"
            @click="terminalArrival()"
            v-permission="permission('zhong:duan:dao:che')"
            >终端到车</el-button
          >
        </template>
        <el-button
          v-if="dispatchType === 'song_huo_shang_men'"
          class="glo_btnItems"
          @click="printNew()"
          >打印</el-button
        >
        <el-button
          class="glo_btnItems"
          @click="printEvent()"
          v-if="dispatchType === 'song_chu_wai_fa'"
          >打印</el-button
        >
        <el-dropdown
          class="topDropDown"
          @command="printIt"
          v-if="dispatchType === 'shang_men_ti_huo'"
        >
          <el-button type="primary">
            打印
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              :command="className.val"
              v-for="className in classNameArr"
              :key="className.val"
              >{{ className.name }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown
          class="topDropDown"
          @command="printLoadAndUnLoad"
          v-if="dispatchType === 'gan_xian_pei_zai'"
        >
          <el-button type="primary">
            打印
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="load">装货作业单</el-dropdown-item>
            <el-dropdown-item command="unLoad">卸货作业单</el-dropdown-item>
            <el-dropdown-item command="hwqd">发车清单(货物清单)</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a" v-if="false">作废</el-dropdown-item>
            <el-dropdown-item
              command="delDispatch"
              v-permission="permission('del')"
              >删除</el-dropdown-item
            >
            <el-dropdown-item
              command="dispatchSure"
              v-permission="permission('confirm:dispatch')"
              >调度确认</el-dropdown-item
            >
            <el-dropdown-item
              command="cancelDispatch"
              v-permission="permission('confirm:dispatch:cancel')"
              >取消调度确认</el-dropdown-item
            >
            <el-dropdown-item
              command="receiveOrder"
              v-permission="permission('driver:receive:order')"
              >司机接单</el-dropdown-item
            >
            <el-dropdown-item
              command="cancelReceiveOrder"
              v-permission="permission('driver:receive:order:cancel')"
              >取消司机接单</el-dropdown-item
            >
            <el-dropdown-item
              command="dispatchcancelStartCar"
              v-permission="permission('confirm:cancel')"
              >取消发车确认</el-dropdown-item
            >
            <el-dropdown-item command="dtdc">导出</el-dropdown-item>
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <queryCondition
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <!-- 表格 -->
    <mytable
      ref="mytable"
      :tableHeigth="tableHeigth"
      :tableData="tableData"
      :myTableHeard="myTableHeard"
      :isShowOperate="isShowOperate"
      :isShowMoreOperate="isShowMoreOperate"
      :btnsList="btnsList"
      :btnsMoreList="btnsMoreList"
      :Operatewidth="Operatewidth"
      @handleCommandBtns="handleCommandBtns"
      :fieldList="fieldList"
      @fildsClick="fildsClick"
    ></mytable>
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <!-- 导出 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      :queryCondditionDatas="queryCondditionDatas"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
    </exportCompoent>
    <!-- 途径网点 -->
    <PassingThroughBranches
      ref="passingThroughBranches"
      :dispatchId="dispatchId"
      v-if="showSetOnway"
      @close="showSetOnway = false"
    />
    <!-- 中途到车/中途发车/终端到车 -->
    <myDialog
      class="ArriveMidway_Dia"
      :diaWidth="'400px'"
      :dialogTitle="arriveDiaTitle"
      :isAppend="true"
      :isShowDialog="showArriveMidwayDia"
      @handleCloseDia="showArriveMidwayDia = false"
      @diaCancelBtn="showArriveMidwayDia = false"
      @diaConfirmBtn="saveArriveMidway"
    >
      <div class="glo_dialogForm">
        <el-form
          v-if="showArriveMidwayDia"
          class="diaForm"
          ref="arriveDialogFormRef"
          :model="arriveDiaForm"
          label-width="120px"
          :rules="rulesForm"
        >
          <el-form-item
            class="dialogFormItemsTime"
            :label="arriveDiaForm.timeLabel"
            prop="arrivalTime"
            required
          >
            <el-date-picker
              v-model="arriveDiaForm.arrivalTime"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              type="datetime"
              placeholder="选择日期时间"
            />
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            :label="arriveDiaForm.deptLabel"
            prop="deptId"
            required
          >
            <el-select
              v-model="arriveDiaForm.deptId"
              placeholder="请选择"
              clearable
              filterable
            >
              <el-option
                v-for="item in businessDepts"
                :key="item.deptId"
                :label="item.deptName"
                :value="item.deptId"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
    <myDialog
      :diaWidth="'900px'"
      dialogTitle="补充信息"
      :isAppend="true"
      :isShowDialog="showAddOtherInfoDia"
      @handleCloseDia="showAddOtherInfoDia = false"
      @diaCancelBtn="showAddOtherInfoDia = false"
      @diaConfirmBtn="saveOtherInfo"
    >
      <el-form label-position="right" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="发车批次号">
              <el-input
                disabled
                v-model="otherInfoForm.dispatchNumber"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车辆类型">
              <el-input
                disabled
                v-model="otherInfoForm.dispatchTypeShow"
              ></el-input>
              <!-- <el-input
                disabled
                v-model="otherInfoForm.dispatchType"
              ></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车牌号">
              <el-input disabled v-model="otherInfoForm.carNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="柜号">
              <el-input disabled v-model="otherInfoForm.trailerNumber"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <add-other-info
        :type="otherInfoForm.dispatchType"
        v-model="otherInfoForm"
      ></add-other-info>
    </myDialog>
    <my-print
      :classNameArr="classNameArr"
      :modelClassName.sync="modelClassName"
      :getApiType.sync="getApiType"
      modelTypeVal="调度配载模块"
      ref="myPrint"
      :dataSource="printDataSource"
      :add-permission="printPermission"
      :edit-permission="printPermission"
      :del-permission="printPermission"
    ></my-print>
  </div>
</template>
<script>
import tableListNew from "@/pages/tableListNew.js"; //mixins 查询列表页公共方法
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import myDialog from "@/components/Dialog.vue";
import mytable from "@/components/table/table.vue";
import queryCondition from "@/components/queryCondition.vue";
import queryBtns from "@/components/queryBtns.vue";
import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
import colorStatus from "@/assets/js/Mixins/colorStatus.js"; //导出的公共js
import PassingThroughBranches from "./PassingThroughBranches.vue";
import MyPrint from "@/components/print/MyPrint.vue";
import AddOtherInfo from "./add/AddOtherInfo.vue";
export default {
  inject: ["reload"],
  mixins: [tableListNew, exportjs, colorStatus],
  props: {
    dispatchType: {
      type: String,
      require: false,
      default: "shang_men_ti_huo",
    },
  },
  components: {
    queryCondition,
    sorttable,
    paging,
    myDialog,
    queryBtns,
    mytable,
    PassingThroughBranches,
    MyPrint,
    AddOtherInfo,
  },
  data() {
    return {
      pageGroupName: "PickupDispatchCar", //  页面标识
      reportFiledsNumber: "admin_dispatch_list_v5", // 动态 条件、表头
      isShowOperate: true, //是否显示右边操作
      isShowMoreOperate: true, //是否显示右边更多操作
      // 表格右边操作按钮
      btnsList: [
        {
          name: "修改", //按钮名称
          methods: "dispatchEdit", //当前页面的方法
          param: 1, //自定义参数标记
          permission: this.permission("edit"),
        },
        {
          name: "详情",
          methods: "dispatchDetail",
          param: 2,
          show: this.dispatchType !== "gan_xian_pei_zai",
          permission: this.permission("detail"),
        },
        {
          name: "装货",
          methods: "addLoadOrder",
          param: 2,
          show: this.dispatchType === "gan_xian_pei_zai",
          permission: this.permission("load"),
        },
        {
          name: "卸货",
          methods: "addUnLoadOrder",
          param: 2,
          show: this.dispatchType === "gan_xian_pei_zai",
          permission: this.permission("unload"),
        },
      ],
      // 表格右边更多的操作按钮
      btnsMoreList: [
        {
          name: "发车完成",
          command: "finishDispatch",
          permission: this.permission("finish"),
        },
        {
          name: "发车确认",
          command: "dispatchConfirm",
          permission: this.permission("confirm"),
        },
        {
          name: "车费摊分",
          command: "allocationCarFee",
          param: 1,
          permission: this.permission("allocation:car:fee"),
        },
        {
          name: "补充信息",
          command: "addOtherInfo",
          param: 1,
          permission: this.permission("allocation:car:fee"),
        },
      ],
      Operatewidth: "220px", //操作列的列宽
      queryCondditionDatas: [
        {
          conditonKey: "dispatchType",
          conditonVal: this.dispatchType + ":dispatch_type",
        },
      ],
      dispatchId: "", // 表格选中id
      showArriveMidwayDia: false,
      arriveDiaTitle: "",
      arriveDiaForm: {
        timeLabel: "",
        deptLabel: "",
        arrivalTime: "",
        deptId: "",
        deptName: "",
        dispatchId: null,
      },
      businessDepts: [], // 网点
      showSetOnway: false,
      rulesForm: {
        deptId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        arrivalTime: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
      },
      fieldList: this.hasPermission("detail") ? ["dispatchNumber"] : [],
      classNameArr: [
        {
          name: "派车单订单",
          val: "com.bami.service.tms.v5.admin.dispatch.vo.print.AdminDispatchCommandPrintDataV5VO",
        },
        {
          name: "派车单运单",
          val: "com.bami.service.tms.v5.admin.dispatch.vo.print.AdminDispatchWaybillPrintDataV5VO",
        },
        {
          name: "派车单提货指令",
          val: "print_door_take_dispatch_data",
        },
      ], // 默认的模板类型
      modelClassName:
        "com.bami.service.tms.v5.admin.dispatch.vo.print.AdminDispatchCommandPrintDataV5VO",
      getApiType: false, //新的获取打印模板字段接口,calssName换成动态查询的number,获取打印数据也有动态查询接口
      song_chu_wai_fa_print_model: 1, //1、装货单；2.卸货单
      showAddOtherInfoDia: false,
      otherInfoForm: {
        dispatchNumber: "",
        weighingWeight: "",
        vehicleTare: "",
        weighingWeightReal: "",
        loadPoint: "",
        routing: "",
        approvalMileage: "",
        drivingMileage: "",
        drivingTime: "",
        highwayEntrance: "",
        highwayExit: "",
        innerLoad: "",
        fuelUse: "",
        totalQuality: "",
        outerCarryingWeight: "",
        loadGoodsWeight: "",
        carrying001: [],
        carrying002: [],
        trailerNumber:'',
        carNumber:'',
      },
    };
  },
  computed: {
    host() {
      return this.getHost();
    },
  },
  updated() {},
  created() {
    switch (this.dispatchType) {
      case "shang_men_ti_huo":
        this.classNameArr = [
          {
            name: "派车单订单",
            val: "com.bami.service.tms.v5.admin.dispatch.vo.print.AdminDispatchCommandPrintDataV5VO",
          },
          {
            name: "派车单运单",
            val: "com.bami.service.tms.v5.admin.dispatch.vo.print.AdminDispatchWaybillPrintDataV5VO",
          },
          {
            name: "派车单提货指令",
            val: "print_door_take_dispatch_data",
          },
        ]; // 默认的模板类型
        this.modelClassName =
          "com.bami.service.tms.v5.admin.dispatch.vo.print.AdminDispatchCommandPrintDataV5VO";
        break;
      case "gan_xian_pei_zai":
        this.classNameArr = [
          // {
          //   name: "发车清单",
          //   val: "com.bami.service.tms.v5.admin.dispatch.vo.print.AdminDispatchFcPrintDataV5VO",
          // },
          {
            name: "发车清单(货物清单)",
            val: "print_line_dispatch_data",
          },
        ]; // 默认的模板类型
        this.modelClassName = "print_line_dispatch_data";
        break;
      case "song_huo_shang_men":
        this.classNameArr = [
          {
            name: "出库单",
            val: "com.bami.service.tms.v5.admin.dispatch.vo.print.AdminDispatchCkPrintDataV5VO",
          },
          {
            name: "送货上门清单打印",
            val: "print_send_dispatch_data", //数据从这个接口获取 /common/v1/print/getPrintList
          },
        ]; // 默认的模板类型
        this.modelClassName =
          "com.bami.service.tms.v5.admin.dispatch.vo.print.AdminDispatchCkPrintDataV5VO";
        break;
      case "song_chu_wai_fa":
        this.classNameArr = [
          {
            name: "送货清单",
            val: "com.bami.service.tms.v5.admin.dispatch.vo.print.AdminDispatchShPrintDataV5VO",
          },
        ]; // 默认的模板类型
        this.modelClassName =
          "com.bami.service.tms.v5.admin.dispatch.vo.print.AdminDispatchShPrintDataV5VO";
        break;
    }
  },
  activated() {},
  mounted() {},
  watch: {
    showArriveMidwayDia(n) {
      if (n) {
        // 网点
        this.getBusinessDepts();
        this.arriveDiaForm.arrivalTime = this.$TOOLS.getCurrentTime();
      } else {
        this.arriveDiaForm = {
          timeLabel: "",
          deptLabel: "",
          arrivalTime: "",
          deptId: "",
          deptName: "",
          dispatchId: null,
        };
      }
    },
  },
  methods: {
    getHost() {
      switch (this.dispatchType) {
        case "shang_men_ti_huo":
          return "shangmentihuo";
        case "gan_xian_pei_zai":
          return "ganxian";
        case "song_huo_shang_men":
          return "songhuoshangmen";
        case "song_chu_wai_fa":
          return "songchuwaifa";
      }
      return "shangmentihuo";
    },
    permission(action) {
      return "admin:dispatch:" + this.getHost() + ":" + action;
    },
    hasPermission(action) {
      return this.hasPermiss(this.permission(action));
    },
    printPermission(action) {
      let scope = "";
      switch (this.modelClassName) {
        case "com.bami.service.tms.v5.admin.dispatch.vo.print.AdminDispatchCommandPrintDataV5VO":
          scope = "commands";
          break;
        case "com.bami.service.tms.v5.admin.dispatch.vo.print.AdminDispatchWaybillPrintDataV5VO":
          scope = "commands";
          break;
        case "com.bami.service.tms.v5.admin.dispatch.vo.print.AdminDispatchFcPrintDataV5VO":
          scope = this.song_chu_wai_fa_print_model === 1 ? "load" : "unload";
          break;
        case "print_door_take_dispatch_data":
          scope = "commands";
          break;
        case "print_line_dispatch_data":
          scope = "load";
          break;
        default:
          scope = "common";
          break;
      }

      return "admin:dispatch:" + this.host + ":print:" + action + ":" + scope;
    },
    async addLoadOrder(row) {
      const res = await this.$API.runList({
        number: "admin_dispatch_load_task_count",
        dispatchId: row.dispatchId,
        operationType: "zhuang_huo:operation_type",
      });
      const exist = res && res[0];
      if (exist) {
        this.$router.push({
          path: "/DispatchCar/EditLoadingOperationSheet",
          query: {
            loadOrderId: exist.id,
            dispatchId: row.dispatchId,
          },
        });
      } else {
        this.$confirm("当前没有待装货的装货单，是否新建一个装货单？")
          .then((res) => {
            this.$router.push({
              path: "/DispatchCar/EditLoadingOperationSheet",
              query: {
                dispatchId: row.dispatchId,
                prev: "/DispatchCar/ganxian",
              },
            });
          })
          .catch((err) => {});
      }
    },
    async addUnLoadOrder(row) {
      const res = await this.$API.runList({
        number: "admin_dispatch_load_task_count",
        dispatchId: row.dispatchId,
        operationType: "xie_huo:operation_type",
      });
      const exist = res && res[0];
      if (exist) {
        this.$router.push({
          path: "/DispatchCar/EditUnloadingOperationSheet",
          query: {
            loadOrderId: exist.id,
            dispatchId: row.dispatchId,
          },
        });
      } else {
        this.$confirm("当前没有待卸货的卸货单，是否新建一个卸货单？")
          .then((res) => {
            this.$router.push({
              path: "/DispatchCar/EditUnloadingOperationSheet",
              query: {
                dispatchId: row.dispatchId,
                prev: "/DispatchCar/ganxian",
              },
            });
          })
          .catch((err) => {});
      }
    },
    // 顶部跟多按钮的操作
    topCommandBtns(command) {
      if (this.topCommandBtnsBak(command)) {
        return;
      }
      if (this.selectTableData.length === 0) {
        this.$message.warning("请先选择表格记录！");
        return;
      }
      this[command]();
    },
    // 获取营业网点
    async getBusinessDepts() {
      const data = await this.$API.runListReport({
        number: "business_dept_down_list",
      });
      this.businessDepts = data;
    },
    handleCommandBtns(command, data) {
      this[command](data);
    },
    // 新建派车--上门提货
    addNewDispatch() {
      let path = "/DispatchCar/PickupDispatchCar/add/" + this.host;
      this.$router.push({
        path,
      });
    },
    dispatchEdit(row) {
      this.$router.push({
        path: "/DispatchCar/PickupDispatchCar/edit/" + this.host,
        query: {
          dispatchId: row.dispatchId,
        },
      });
    },
    dispatchDetail(row) {
      // this.$router.push({
      //   path: "/DispatchCar/PickupDispatchCar/add/" + this.host,
      //   query: {
      //     op: "view",
      //     isSee: 1,
      //     dispatchId: row.dispatchId,
      //   },
      // });
      this.$router.push({
        path: "/DispatchCar/CarTiming",
        query: {
          dispatchNumber: row.dispatchNumber,
        },
      });
    },
    // 途径网点
    passingBranches(row) {
      if (this.selectTableData.length === 0) {
        this.$message.warning("请选择一条派车单进行操作");
        return;
      }
      this.dispatchId = this.selectTableData[0].dispatchId;
      this.showSetOnway = true;
      this.$nextTick(() => {
        this.$refs.passingThroughBranches.isShowDialog = true;
      });
    },
    // 中途到车/中途发车/终端到车弹窗保存回调
    saveArriveMidway() {
      this.$refs.arriveDialogFormRef.validate((valid) => {
        let path = "";
        let params = {
          dispatchIds: this.selectTableData.map((item) => item.dispatchId),
          deptId: this.arriveDiaForm.deptId,
        };
        switch (this.arriveDiaType) {
          case "ztdc":
            path = "arrivalMidway";
            params.actualArrivalTime = this.arriveDiaForm.arrivalTime;
            break;
          case "ztfc":
            path = "startMidway";
            params.departureTime = this.arriveDiaForm.arrivalTime;
            break;
          case "zddc":
            path = "arrivalEndDept";
            params.arrivalEndDeptTime = this.arriveDiaForm.arrivalTime;
            break;
        }
        this.$API[path](params).then((res) => {
          this.$message.success("保存成功");
        });
      });
    },
    async saveOtherInfo() {
      await this.$API.addOtherInfo({
        ...this.otherInfoForm,
      });
      this.$message.success("保存成功");
      this.showAddOtherInfoDia = false;
    },
    // 中途到车
    arriveMidway(row) {
      if (this.selectTableData.length === 0) {
        this.$message.warning("请选择一条派车单进行操作");
        return;
      }
      this.arriveDiaTitle = "中途到车";
      this.arriveDiaType = "ztdc";
      this.arriveDiaForm.timeLabel = "到车时间";
      this.arriveDiaForm.deptLabel = "到车网点";
      this.arriveDiaForm.dispatchId = ""; // row.dispatchId
      this.showArriveMidwayDia = true;
    },
    // 中途发车
    departureMidway(row) {
      if (this.selectTableData.length === 0) {
        this.$message.warning("请选择一条派车单进行操作");
        return;
      }
      this.arriveDiaTitle = "中途发车";
      this.arriveDiaType = "ztfc";
      this.arriveDiaForm.timeLabel = "发车时间";
      this.arriveDiaForm.deptLabel = "下一站网点";
      this.arriveDiaForm.dispatchId = ""; // row.dispatchId
      this.showArriveMidwayDia = true;
    },
    // 终端到车
    terminalArrival(row) {
      if (this.selectTableData.length === 0) {
        this.$message.warning("请选择一条派车单进行操作");
        return;
      }
      this.arriveDiaTitle = "终端到车";
      this.arriveDiaType = "zddc";
      this.arriveDiaForm.timeLabel = "到车时间";
      this.arriveDiaForm.deptLabel = "终端网点";
      this.arriveDiaForm.dispatchId = ""; // row.dispatchId
      this.showArriveMidwayDia = true;
    },
    dispatchConfirm(row) {
      let rows = [];
      if (row) {
        rows.push(row);
      } else {
        if (this.selectTableData.length == 0) {
          this.$message.warning("请选择一条派车单进行操作");
          return;
        }
        rows = this.selectTableData;
      }
      console.log(rows);
      const dispatchIds = rows.map((item) => item.dispatchId);
      this.$confirm("是否对已选数据进行发车确认？", "提示")
        .then((res) => {
          this.$API
            .startCar({
              dispatchIds,
            })
            .then((res) => {
              this.$message.success("发车确认成功");
              this.getData();
            })
            .catch((res) => {
              this.$message.error("发车确认失败:" + res.data.message);
            });
        })
        .catch((err) => {});
    },
    intoStoreage() {
      if (this.selectTableData.length !== 1) {
        this.$message.warning("请选择一条派车单进行操作");
        return;
      }
      const row = this.selectTableData[0];
      // this.$router.push({
      //   path: "/DispatchCar/PickupDispatchCar/add/intoStoreageDispatchCar",
      //   query: {
      //     type: this.dispatchType,
      //     op: "intoStoreage",
      //     dispatchId: row.dispatchId,
      //   },
      // });
      this.$router.push({
        path: "/DispatchCar/EditUnloadingOperationSheet/intoStoreage",
        query: {
          dispatchId: row.dispatchId,
        },
      });
    },
    finishDispatch(row) {
      let rows = [];
      if (row) {
        rows.push(row);
      } else {
        if (this.selectTableData.length == 0) {
          this.$message.warning("请选择一条派车单进行操作");
          return;
        }
        rows = this.selectTableData;
      }
      const dispatchIds = rows.map((item) => item.dispatchId);
      this.$confirm("是否对已选数据进行发车完成？", "提示")
        .then((res) => {
          this.$API
            .endCar({
              dispatchIds,
            })
            .then((res) => {
              this.$message.success("发车完成成功");
              this.getData();
            })
            .catch((res) => {
              const target = res.data.target;
              if (target === "notComplete") {
                this.warningNotComplete(rows[0]);
              } else {
                this.$message.error("发车完成失败:" + res.data.message);
              }
            });
        })
        .catch((err) => {});
    },
    warningNotComplete(row) {
      const dispatchId = row.dispatchId;
      this.$confirm("车次存在未卸货完成的任务，是否把车次内所有任务都卸货完成")
        .then((res) => {
          this.$API
            .finishAllTask({
              dispatchId,
            })
            .then((res) => {
              this.$message.success("车次已全部卸货完成");
              this.getData();
            })
            .catch((err) => {
              this.$message.success("车次卸货失败");
            });
        })
        .catch((err) => {});
    },
    feeCheckIn(row) {
      if (!row) {
        if (this.selectTableData.length !== 1) {
          this.$message.warning("请选择一条派车单进行操作");
          return;
        }
        row = this.selectTableData[0];
      }
      this.$router.push({
        path: "/DispatchCar/PickupDispatchCar/add/FeeCheckInDispatchCar",
        query: {
          type: this.dispatchType,
          op: "feeCheckIn",
          dispatchId: row.dispatchId,
        },
      });
    },
    batchSignDispatch() {
      if (this.selectTableData.length !== 1) {
        this.$message.warning("请选择一条派车单进行操作");
        return;
      }
      const row = this.selectTableData[0];
      if (row.dispatchStatus === "yi_wan_cheng:dispatch_status") {
        this.$message.error("改派车单已完成");
        return;
      }
      this.$router.push({
        path: "/WaybillManage/sign/sign",
        query: {
          dispatchId: row.dispatchId,
        },
      });
    },
    batchCheckFee(row) {
      if (this.selectTableData.length !== 1) {
        this.$message.warning("请选择一条派车单进行操作");
        return;
      }
      this.$confirm("是否对已选数据进行财务审核过账？")
        .then((res) => {
          this.$API
            .batchPostingDispatch({
              dispatchIds: this.selectTableData.map((item) => item.dispatchId),
            })
            .then((res) => {
              this.$message.success("过账成功");
              this.getData();
            });
        })
        .catch((err) => {});
    },
    batchCheckFeeOut() {
      if (this.selectTableData.length !== 1) {
        this.$message.warning("请选择一条派车单进行操作");
        return;
      }
      this.$confirm("是否对已选数据进行反过账？")
        .then((res) => {
          this.$API
            .wtl_unpostingDispatch({
              dispatchIds: this.selectTableData.map((item) => item.dispatchId),
            })
            .then((res) => {
              this.$message.success("反过账成功");
              this.getData();
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    allocationCarFee(row) {
      this.$router.push({
        path: "/DispatchCar/PickupDispatchCar/allocation/fee",
        query: {
          dispatchId: row.dispatchId,
        },
      });
    },
    async addOtherInfo(row) {
      console.log('row',row)
      const res = await this.$API.dispatchWorkers({
        dispatchId: row.dispatchId,
      });
      this.otherInfoForm = row;
      this.otherInfoForm.carrying001 = res.data.result.carrying001;
      this.otherInfoForm.carrying002 = res.data.result.carrying002;
      this.showAddOtherInfoDia = true;
    },
    delDispatch() {
      this.$confirm("是否对已选数据进行删除？").then((res) => {
        this.$API
          .delDispatch({
            dispatchIds: this.getDispatchIds(),
          })
          .then((res) => {
            this.$message.success("删除成功");
            this.getData();
          });
      });
    },
    dispatchSure() {
      this.$confirm("是否对已选数据进行调度确认？").then((res) => {
        this.$API
          .dispatchSure({
            dispatchIds: this.getDispatchIds(),
          })
          .then((res) => {
            this.$message.success("调度确认成功");
            this.getData();
          });
      });
    },
    cancelDispatch() {
      this.$confirm("是否对已选数据取消调度确认？").then((res) => {
        this.$API
          .cancelDispatch({
            dispatchIds: this.getDispatchIds(),
          })
          .then((res) => {
            this.$message.success("调度取消成功");
            this.getData();
          });
      });
    },
    receiveOrder() {
      this.$confirm("是否对已选数据进行司机接单？").then((res) => {
        this.$API
          .wtl_receiveOrder({
            dispatchIds: this.getDispatchIds(),
          })
          .then((res) => {
            this.$message.success("司机接单成功");
            this.getData();
          });
      });
    },
    cancelReceiveOrder() {
      this.$confirm("是否对已选数据取消司机接单？").then((res) => {
        this.$API
          .cancelReceiveOrder({
            dispatchIds: this.getDispatchIds(),
          })
          .then((res) => {
            this.$message.success("司机接单取消成功");
            this.getData();
          });
      });
    },
    dispatchcancelStartCar() {
      this.$confirm("是否对已选数据取消发车确认？").then((res) => {
        this.$API
          .cancelStartCar({
            dispatchIds: this.getDispatchIds(),
          })
          .then((res) => {
            this.$message.success("发车确认取消成功");
            this.getData();
          });
      });
    },
    getDispatchIds() {
      return this.selectTableData.map((item) => item.dispatchId);
    },
    dispatchNumberClickHandler(row) {
      this.dispatchDetail(row);
    },
    printIt(command) {
      this.modelClassName = command;
      this.getApiType =
        command === "print_door_take_dispatch_data" ? true : false;

      this.printEvent();
    },
    printNew() {
      // if (this.selectTableData.length > 1) {
      //   this.$message.warning("请选择一条派车单进行操作");
      //   return false;
      // }
      this.modelClassName = "print_send_dispatch_data";
      this.getApiType = true;
      this.printEvent();
    },

    printLoadAndUnLoad(command) {
      if (command === "hwqd") {
        this.modelClassName = "print_line_dispatch_data";
        this.getApiType = true;
        this.printEvent();
      } else {
        this.getApiType = false;
        this.modelClassName =
          "com.bami.service.tms.v5.admin.dispatch.vo.print.AdminDispatchFcPrintDataV5VO";
        this.song_chu_wai_fa_print_model = command === "load" ? 1 : 2;
        this.printEvent();
      }
    },
    printDataSource(rows, modelClassName) {
      console.log("rowsA", rows);
      console.log("modelClassName", modelClassName);
      const dispatch = rows;
      switch (modelClassName) {
        // 干线派车打印
        case "print_line_dispatch_data":
          if (rows && rows.length > 0) {
            return new Promise((resolve, reject) => {
              this.$API
                .runList({
                  number: modelClassName,
                  dispatchIds: rows.map((d) => d.dispatchId),
                  // dispatchId: rows[0].dispatchId,
                })
                .then((res) => {
                  const result = res;
                  resolve(result);
                })
                .catch((err) => {});
            });
          }
        case "print_send_dispatch_data":
          if (rows && rows.length > 0) {
            return new Promise((resolve, reject) => {
              this.$API
                .runList({
                  number: modelClassName,
                  dispatchIds: rows.map((d) => d.dispatchId),
                  // dispatchId: rows[0].dispatchId,
                })
                .then((res) => {
                  const result = res;
                  resolve(result);
                })
                .catch((err) => {});
            });
          }
        case "print_door_take_dispatch_data":
          if (rows && rows.length > 0) {
            return new Promise((resolve, reject) => {
              this.$API
                .runList({
                  number: modelClassName,
                  dispatchIds: rows.map((d) => d.dispatchId),
                  // dispatchId: rows[0].dispatchId,
                })
                .then((res) => {
                  const result = res;
                  resolve(result);
                })
                .catch((err) => {});
            });
          }

        case "com.bami.service.tms.v5.admin.dispatch.vo.print.AdminDispatchShPrintDataV5VO":
          return new Promise((resolve, reject) => {
            this.$API
              .shPrintData({
                dispatchIds: dispatch.map((d) => d.dispatchId),
              })
              .then((res) => {
                const result = res.data.result;
                resolve(result);
              })
              .catch((err) => {});
          });
        case "com.bami.service.tms.v5.admin.dispatch.vo.print.AdminDispatchFcPrintDataV5VO":
          if (this.song_chu_wai_fa_print_model === 1) {
            return new Promise((resolve, reject) => {
              this.$API
                .dispatchLoadFcPrintData({
                  dispatchIds: dispatch.map((d) => d.dispatchId),
                })
                .then((res) => {
                  const result = res.data.result;
                  resolve(result);
                })
                .catch((err) => {});
            });
          }
          return new Promise((resolve, reject) => {
            this.$API
              .dispatchUnLoadFcPrintData({
                dispatchIds: dispatch.map((d) => d.dispatchId),
              })
              .then((res) => {
                const result = res.data.result;
                resolve(result);
              })
              .catch((err) => {});
          });
        default:
          return new Promise((resolve, reject) => {
            this.$API
              .commandPrintData({
                dispatchIds: dispatch.map((d) => d.dispatchId),
                type:
                  modelClassName ===
                  "com.bami.service.tms.v5.admin.dispatch.vo.print.AdminDispatchShPrintDataV5VO"
                    ? 1
                    : 2,
              })
              .then((res) => {
                const result = res.data.result;
                resolve(result);
              })
              .catch((err) => {});
          });
      }
    },
  },
};
</script>
<style scoped lang="less">
.el-dialog__wrapper {
  .el-dialog {
    .el-dialog__body {
      .glo_dialogForm {
        .dialogFormItems {
          min-width: 345px;
        }
      }
    }
  }
}
.tableBox {
  height: calc(100% - 260px);
}

.colorStyle {
  color: #f00;
}

.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}

.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }

  .timeBox {
    border: 1px solid #d7d7d7;
  }
}

.headerboxs {
  width: 100%;
  padding: 5px 0;
  display: flex;
  align-items: center;
}

.iconInput {
  display: flex;
  align-items: center;
}
.mainCOlorBtns {
  background-color: #f0a261;
  color: #fff;
  border: none;
}
.mainCOlorBtns :hover {
  color: #fff;
}
</style>
